import { useGlobalHomeSelectStore } from '@/features/shop/components/GlobalHomePage/useGlobalHomeSelectStore'
import { useQueryShoppingStores } from '@/features/shop/services/ShoppingStore/queries'
import { type Promotion } from '@/features/shop/services/Campaigns/types'
import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicCMSPromotionTermsDrawer } from '@/features/shop/components/Drawer/CMSPromotionTermsDrawer/DynamicCMSPromotionTermsDrawer'
import { getNormalizedPromoUrl } from '@/features/cms/components/CMS/utils/getNormalizedPromoUrl'

export const useSelectPromoStore = (promotion: Promotion, destinationUrl: string) => {
  const router = useSegwayRouter()
  const { openDialog } = useHandleDialog()
  const { data: shoppingStores } = useQueryShoppingStores()
  const { selectStore, isLoading } = useGlobalHomeSelectStore(promotion)

  const availableStoreIds = promotion.available_store_ids ?? []
  const storesCount = availableStoreIds.length
  const { normalizedUrl, promoStore } = getNormalizedPromoUrl({
    destinationUrl,
    availableStoreIds,
    deliveryStores: shoppingStores?.delivery_stores,
  })
  const renderLinkInCard = Boolean(promoStore)

  const selectPromoStore = () => {
    if (promotion.terms && storesCount !== 1) {
      openDialog(DynamicCMSPromotionTermsDrawer, {
        promotion,
        destinationUrl: normalizedUrl,
      })
      return
    }

    if (promotion.skip_store_selection) {
      router.push(normalizedUrl)
      return
    }

    switch (storesCount) {
      case 0:
        router.push(destinationUrl)
        break
      case 1:
        if (promoStore) {
          selectStore(promoStore, normalizedUrl)
        }

        break
      default:
        openDialog(DynamicCMSPromotionTermsDrawer, {
          promotion,
          destinationUrl: normalizedUrl,
        })
        break
    }
  }
  return { selectPromoStore, normalizedUrl, isLoading, renderLinkInCard }
}
